import React, { ChangeEvent, ReactElement, useState } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

import AuthLayout from '../../../../layouts/auth/AuthLayout';
import Button from '../../../common/button/Button';
import PasswordValidation from '../../../common/validation/password-validation/PasswordValidation';
import PasswordInput from '../../../common/input/password-input/PasswordInput';

import './reset-password.scss';

type Props = {
  resetPassword: (password: string, callback: () => void) => void;
};

const ResetPassword = ({ resetPassword }: Props): ReactElement => {
  const [password, setPassword] = useState<string>('');
  const [confirmationPassword, setConfirmationPassword] = useState<string>('');
  const [passwordReset, setPasswordReset] = useState<boolean>(false);
  const [validPassword, setValidPassword] = useState<boolean>(false);

  const navigate: NavigateFunction = useNavigate();

  const renderFields = (): ReactElement => (
    <>
      <p className="reset-password__message">Please enter your new password:</p>
      <div className="reset-password__input-container">
        <PasswordInput
          value={password}
          onChange={({ target }: ChangeEvent<HTMLInputElement>): void => setPassword(target.value)}
          placeholder="password"
        />

        <PasswordInput
          value={confirmationPassword}
          onChange={({ target }: ChangeEvent<HTMLInputElement>): void => setConfirmationPassword(target.value)}
          placeholder="confirm password"
        />

        <PasswordValidation
          password={password}
          confirmationPassword={confirmationPassword}
          setValidPassword={setValidPassword}
        />
      </div>

      <div className="reset-password__button-container">
        <Button
          text="Reset Password"
          disabled={!validPassword}
          onClick={(): void => resetPassword(password, (): void => setPasswordReset(true))}
          auth
        />
      </div>
    </>
  );

  return (
    <AuthLayout>
      <div className="reset-password">
        {passwordReset ? (
          <>
            <div className="reset-password__success-message-container">
              <p className="reset-password__message">Thank you.</p>
              <p className="reset-password__message">Your password has been reset.</p>
            </div>
            <div className="reset-password__button-container">
              <Button text="Return Home" onClick={(): void => navigate('/')} auth />
            </div>
          </>
        ) : (
          renderFields()
        )}
      </div>
    </AuthLayout>
  );
};

export default ResetPassword;
